import React from 'react';
import {stylesCFS} from "../../../styles/favoriteServices";
import { ClaroModalCardOk } from "@claropay/shared";

export default class FavoriteElement extends React.Component {
  constructor(props) {
    super(props);
  } 

  componentDidMount() {

  }

  getStyles() {
    return stylesCFS;
  }

  referenceHandleClick(accountService){ 
    const {executeTaggeo, tagServiceId, handleSetFavValue, closeModalFavoriteServices} = this.props;

    executeTaggeo({
      action: "Click Guardado",
      step: "Servicios guardados",
      service: tagServiceId,
    });
    handleSetFavValue(accountService);
    closeModalFavoriteServices();
  }

  editHandleClick(lidFavorite,accountService, alias){
    const {executeTaggeo, tagServiceId, openEditFavoriteService} = this.props;

    executeTaggeo({
      action: "Click Editar",
      step: "Servicios guardados",
      service: tagServiceId,
    });
    openEditFavoriteService(lidFavorite, accountService, alias);
  }

  deleteHandleClick(lidFavorite){
    const {executeTaggeo, tagServiceId, openDeleteFavoriteService} = this.props;

    executeTaggeo({
      action: "Click Eliminar",
      step: "Servicios guardados",
      service: tagServiceId,
    });
    openDeleteFavoriteService(lidFavorite);
  }

  render(){
    const styles = this.getStyles();
    const {accountService, alias, lidFavorite} = this.props.fav;
    const {mediaService} = this.props;
    
    return(
      <>
        <div style={ styles.listFavsItem }>
          <div style={ styles.info} 
            onClick={() => { this.referenceHandleClick(accountService); }}
          >
            <p style={ styles.alias }>{alias}</p>
            <p style={ styles.reference }>{accountService}</p>
          </div>
          <div style={ styles.controlIcon }>
            <span style={ styles.leftBorder }></span>
            <button 
              style={ styles.buttonIcon }
              onClick={() => { this.editHandleClick(lidFavorite,accountService, alias); }} 
            >
              <img
                src={mediaService.imgEdit ? mediaService.imgEdit : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjQ2IDIxLjI0IDIxLjI1IDYuNDVsLTMuNy0zLjdMMi43NiAxNy41NGwtLjAxIDMuNzEgMy43MS0uMDF6TTE1LjM1IDYuMTNsMi41MiAyLjUyIiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="}
                height="24"
                width="24"
              />
            </button>
            <span style={ styles.rightBorder }></span>
          </div>
          <div style={ styles.controlIcon }>
            <button 
              style={ styles.buttonIcon }
              onClick={() => { this.deleteHandleClick(lidFavorite);}}  
            >  
            <img
                src={mediaService.imgDelete ? mediaService.imgDelete : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNy45NiA1LjgzSDUuNjl2MTMuMzZjMCAxLjEzLjkyIDIuMDUgMi4wNSAyLjA1aDguMTZjMS4xMyAwIDIuMDUtLjkyIDIuMDUtMi4wNVY1LjgzaC4wMXpNMy43OSA1LjgzaDE2LjQyTTE1LjA4IDIuNzRIOC45MnYzLjA4aDYuMTZWMi43NHpNOS45NCA5Ljc1djcuMzlNMTQuMDUgOS43NXY3LjM5IiBzdHJva2U9IiNEMzIyMjIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="}
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>
      </>
    )
  }
}